import React, { useEffect, useState } from "react";
import { IsAlert } from "../component/atoms/IsAlert";
import { fetchApi } from "../helper/api";
import TablePagination from "@mui/material/TablePagination";
import { Grid } from "@mui/material";
import CardFieldReport from "../component/atoms/CardFieldReport";
import FieldReportDetails from "../component/molecules/popup/FieldReportDetails";

const defaultDataFieldReport = {
  metaPagination: {
    currentPage: 0,
    dataCount: null,
    info: null,
    maxPage: null,
    pageSize: null,
  },
  fieldReportsRes: [],
};

function FieldReport() {
  // inisiasi variabel
  const [dataFieldReport, setDataFieldReport] = useState(defaultDataFieldReport);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(9);
  const [frDetail, setFrDetail] = useState(null);

  const fetchFieldReportData = async () => {
    const req = await fetchApi(
      `api/FieldReport?page=${page + 1
      }&pageSize=${rowsPerPage}`,
      "get",
      true
    );
    const res = await req.json();
    const status = req.status;
    if (status === 200) {
      // console.log("DATA HISTORY", res.data);
      setDataFieldReport(res.data);
    } else {
      // console.log("ERROR FETCH HISTORY");
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const value = event.target.value;
    setRowsPerPage(parseInt(value, 10));
    setPage(0);
  };

  const handleDelete = (id) => {
    IsAlert.fire({
      title: "",
      text: "Apakah anda yakin?",
      icon: "warning",
      showCancelButton: false,
      focusConfirm: true,
      confirmButtonText: 'OK',
      showCancelButton: true

    }).then(function (isConfirm) {
      if (isConfirm.isConfirmed) {
        console.log("Delete fr : ", id);
        deleteFr(id)
      }
    })
  }

  const handleDetails = (item) => {
    setFrDetail(item)
    console.log("Details FR", item);
  }

  const deleteFr = async (id) => {
    var req = await fetchApi(`api/FieldReport/${id}`, "DELETE", true)
    var status = req.status
    if (status === 200) {
      fetchFieldReportData()
    }
  }

  useEffect(() => {
    fetchFieldReportData();
  }, []);

  useEffect(() => {
    fetchFieldReportData();
    setPage(0);
  }, [rowsPerPage]);

  useEffect(() => {
    fetchFieldReportData();
  }, [page]);

  return (
    <div className="p-2">
      <h1 className='mb-2'>Field Report</h1>
      {/* modal disini */}
      {frDetail && (
        <FieldReportDetails dataDetails={frDetail} />
      )}
      {dataFieldReport.fieldReportsRes.length === 0 ? (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <span className="text-center">Belum ada laporan masuk. </span>
        </div>
      ) : (
        <>
          {/* render list field report */}
          <Grid container spacing={4}>
            {dataFieldReport?.fieldReportsRes?.map((item, i) => (
              <Grid key={i} item xs={12} md={6} lg={4} xl={2}>
                <CardFieldReport item={item} deleteCallback={handleDelete} detailsCallback={handleDetails} />
              </Grid>
            ))}
          </Grid>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              marginTop: 16
            }}
          >
            <TablePagination
              className="pagination"
              component="div"
              count={dataFieldReport?.metaPagination?.dataCount ?? 0}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[3, 6, 9, 18]}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>
        </>

      )}
    </div>
  )

}
export default FieldReport